import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Header from '../include/Header';
import Sidebar from '../include/Sidebar';
import axios from 'axios';
import { PAY_URL } from '../../../BaseURL';
import toast from 'react-hot-toast';
import moment from 'moment';


const ManageUser = () => {


    const location = useLocation();
    const navigate = useNavigate();
    const [disable, setDisable] = useState(false);
    const [error, setError] = useState({});
    const data = location.state;


    const [user, setUser] = useState({
        user_name: "",
        email: "",
        password: "",
        year: "",
        pwdShow: true,
        pay_subUser: false,
        pay_bankDetail: false,
    });

    useEffect(() => {
        setUser(prevUser => ({
            ...prevUser,
            user_name: data?.user_name,
            email: data?.email,
            year: data?.year?._id,
            pay_subUser: data?.pay_subUser || false,
            pay_bankDetail: data?.pay_bankDetail || false,
        }));

        setSelectValue(data?.status);

        setSelectedFirm(data?.firm?.map(e => ({ id: e?._id })) || []);
        setSelectedYear(data?.year?.map(e => ({ id: e?._id })) || []);

    }, [data]);

    const [year, setYear] = useState([]);
    const [firm, setFirm] = useState([]);
    const [selectValue, setSelectValue] = useState('');

    const [selectedFirm, setSelectedFirm] = useState([]);
    const [selectedYear, setSelectedYear] = useState([])


    useEffect(() => {
        if (localStorage.getItem('PAY_ADMIN_TOKEN') === null) {
            navigate("/admin/login");
        }
    }, []);

    useEffect(() => {
        getYear();
        getFirm();
    }, []);


    const getYear = () => {
        const myurl = `${PAY_URL}/admin/get-year`;
        axios({
            method: "get",
            url: myurl,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_ADMIN_TOKEN') },
        }).then((response) => {
            // console.log(response.data, '@@');
            if (response?.data?.success === true) {
                setYear(response?.data?.data);
            } else {
                toast.error("Something went wrong");
            }
        }).catch((error) => {
            toast.error("Something went wrong");
            console?.log("Errors", error);
        })
    }

    const getFirm = () => {
        const myurl = `${PAY_URL}/admin/get-firm`;
        axios({
            method: "get",
            url: myurl,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_ADMIN_TOKEN') },
        }).then((response) => {
            // console.log(response.data, '@@');
            if (response?.data?.success === true) {
                setFirm(response?.data?.data);
            } else {
                toast.error("Something went wrong");
            }
        }).catch((error) => {
            toast.error("Something went wrong");
            console?.log("Errors", error);
        })
    }

    const handleRadioChange = (event) => {
        setSelectValue(event.target.checked);
    };

    const handleChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value })
    }

    const handleSwitchChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.checked })
    }


    const handleCheckboxChange = (event, elem) => {
        const isChecked = event.target.checked;
        if (isChecked) {
            setSelectedFirm(prevSelected => {
                const selectedArray = Array.isArray(prevSelected) ? prevSelected : [];
                return [...selectedArray, { id: elem._id }];
            });
        } else {
            setSelectedFirm(prevSelected => {
                const selectedArray = Array.isArray(prevSelected) ? prevSelected : [];
                return selectedArray.filter(item => item.id !== elem._id);
            });
        }
    }

    const handleYearCheckBox = (event, elem) => {
        const isChecked = event.target.checked;

        if (isChecked) {
            setSelectedYear(prevSelected => {
                const selectedArray = Array.isArray(prevSelected) ? prevSelected : [];
                return [...selectedArray, { id: elem._id }];
            });
        } else {
            setSelectedYear(prevSelected => {
                const selectedArray = Array.isArray(prevSelected) ? prevSelected : [];
                return selectedArray.filter(item => item.id !== elem._id);
            });
        }
    }

    // console.log(selectedYear, '@@@')

    const handleSubmit = () => {
        if (validation()) {
            setDisable(true);

            const bodyFormData = new URLSearchParams();
            bodyFormData.append('user_name', user?.user_name);
            bodyFormData.append('email', user.email);
            if (user?.password !== '') {
                bodyFormData.append('password', user.password);
            }
            bodyFormData.append('year', JSON.stringify(selectedYear));
            bodyFormData.append('firm', JSON.stringify(selectedFirm));
            bodyFormData.append('pay_subUser', user.pay_subUser);
            bodyFormData.append('pay_bankDetail', user.pay_bankDetail);


            if (data?._id) {
                bodyFormData.append('status', selectValue);
                bodyFormData.append('id', data?._id);
            }

            axios({
                method: 'post',
                url: `${PAY_URL}/admin/manage-user`,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: "Bearer " + localStorage.getItem('PAY_ADMIN_TOKEN') }
            }).then((response) => {
                // console.log(response.data, '@@');

                if (response.data.success === true) {
                    toast.success(response.data.message);
                    navigate('/admin/user-management');

                    setUser({
                        user_name: "",
                        email: "",
                        password: "",
                        year: "",
                        pwdShow: true,
                        pay_subUser: false,
                        pay_bankDetail: false,
                    })

                    setDisable(false);
                }
            }).catch((error) => {
                console.log(error);
                toast.error(error.response.data.message);
                setDisable(false);
            })
        }
    }

    const validation = () => {
        let isValid = true;
        let err = {};

        if (!user?.user_name || !user?.user_name?.trim()) {
            isValid = false;
            err['user_name_err'] = "Please enter user name"
        }

        if (!user.email) {
            isValid = false;
            err['email_err'] = "Please enter email"
        } else if (typeof user.email !== "undefined") {
            let lastAtPos = user.email.lastIndexOf('@');
            let lastDotPos = user.email.lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && user.email.indexOf('@@') === -1 && lastDotPos > 2 && (user?.email?.length - lastDotPos) > 2)) {
                isValid = false;
                err["email_err"] = "Email is not valid";
            }
        }

        if (!data?._id) {
            if (!user?.password) {
                isValid = false;
                err["password_err"] = "Please enter password";
            } else if (!/(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[a-z]).{8,}/.test(user.password)) {
                isValid = false;
                err["password_err"] = "Password must contain at least one uppercase letter, one special character, and be at least 8 characters long";
            }
        }

        if (selectedYear.length === 0) {
            isValid = false;
            err["year_err"] = "Please select atleast one year";
        }

        if (selectedFirm.length === 0) {
            isValid = false;
            err["firm_err"] = "Please select atleast one firm";
        }

        setError(err);
        return isValid
    }

    const handleReset = () => {
        setUser({
            user_name: "",
            email: "",
            password: "",
            year: "",
            pay_subUser: false,
            pay_bankDetail: false,
        });
        setSelectedFirm([]);
        setSelectedYear([]);
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title">{data?._id ? 'Edit' : 'Add'} User</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"><Link to='/admin/user-management'>User Management</Link></li>
                                    <li className="breadcrumb-item active">{data?._id ? 'Edit' : 'Add'} User</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="card p-3 basicform">
                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label htmlFor="firmName" className="form-label">User Name</label>
                                        <input type="text" className="form-control"
                                            value={user.user_name}
                                            name='user_name' onChange={handleChange} />
                                        <div className='error'>{error.user_name_err}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <input type="email" className="form-control"
                                            value={user.email}
                                            name='email' onChange={handleChange} />
                                        <div className='error'>{error.email_err}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3 position-relative">
                                        <label className="form-label">Password</label>
                                        <input type={user.pwdShow ? "password" : "text"} className="form-control position-relative"
                                            value={user.password}
                                            name='password' onChange={handleChange} />
                                        {user.pwdShow ? <div className="input-icon profilePassword" onClick={() => { setUser({ ...user, pwdShow: false }) }}><i className='fa-solid fa-eye' /></div> : <div className='input-icon profilePassword' onClick={() => setUser({ ...user, pwdShow: true })}><i className='fa-solid fa-eye-slash' /> </div>}
                                        <div className='error'>{error.password_err}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row card_id">

                            {data?._id ? (
                                <div className='col-md-4 col-lg-4 col-xxl-4 col-sm-12'>
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="fileUpload" className="form-label">Status</label>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" role="switch" onChange={handleRadioChange} checked={selectValue} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            <div className='col-md-4 col-lg-4 col-xxl-4 col-sm-12'>
                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label htmlFor="pay_subUser" className="form-label">Pay Subuser</label>
                                        <div className="form-check form-switch">
                                            <input name="pay_subUser" className="form-check-input" type="checkbox" role="switch" onChange={handleSwitchChange} checked={user.pay_subUser} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-4 col-lg-4 col-xxl-4 col-sm-12'>
                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label htmlFor="pay_bankDetail" className="form-label">Pay Bank Detail</label>
                                        <div className="form-check form-switch">
                                            <input name="pay_bankDetail" className="form-check-input" type="checkbox" role="switch" onChange={handleSwitchChange} checked={user.pay_bankDetail} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='card p-3 basicform'>
                        <div className=" mb-3 titleForm border-bottom d-flex align-items-center justify-content-between">
                            <div className='mb-2'>
                                <h4 className="m-0">Year</h4>
                            </div>
                            <div className='mb-2'>
                                {selectedYear?.length > 0 ? (
                                    <button className='btn btn-primary' type='button'>{selectedYear?.length}</button>
                                ) : null}
                            </div>
                        </div>

                        <div className='row card_id'>
                            <table className="table table-bordered table-hover w-100">
                                <thead>
                                    <tr>
                                        <th scope='col'>Year</th>
                                        <th scope="col">Start Year</th>
                                        <th scope="col">End Year</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {year?.map((elem, i) =>
                                        <tr key={elem?._id}>
                                            <td>
                                                <div className='d-flex firm-check gap-2 align-items-center'>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox"
                                                            onChange={(event) => handleYearCheckBox(event, elem)}
                                                            checked={selectedYear?.some(item => item.id === elem?._id)} />
                                                    </div>
                                                    <div>
                                                        {`${moment(elem?.start_year).format('YYYY')}-${moment(elem?.end_year).format('YYYY')}`}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{moment(elem?.start_year).format('YYYY-MM-DD')}</td>
                                            <td>{moment(elem?.end_year).format('YYYY-MM-DD')}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className='error'>{error?.firm_err}</div>
                        </div>
                    </div>

                    <div className="card p-3 basicform">
                        <div className=" mb-3 titleForm border-bottom d-flex align-items-center justify-content-between">
                            <div className='mb-2'>
                                <h4 className="m-0">Firm</h4>
                            </div>
                            <div className='mb-2'>
                                {selectedFirm?.length > 0 ? (
                                    <button className='btn btn-primary' type='button'>{selectedFirm?.length}</button>
                                ) : null}
                            </div>
                        </div>

                        <div className='row card_id'>
                            <table className="table table-bordered table-hover w-100">
                                <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Register No.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {firm?.map((elem, i) =>
                                        <tr key={elem?._id}>
                                            <td>
                                                <div className='d-flex firm-check gap-2 align-items-center'>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox"
                                                            onChange={(event) => handleCheckboxChange(event, elem)}
                                                            checked={selectedFirm?.some(item => item.id === elem?._id)} />
                                                    </div>
                                                    <div>
                                                        {elem?.name}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{elem?.register_no}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className='error'>{error?.firm_err}</div>
                        </div>

                        <div className="row card_id mt-4 sm-mt-3">
                            <div className=" col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3 d-flex gap-2">
                                        <button className="btn btn-primary w-50" type='button' onClick={handleSubmit} disabled={disable}>{disable ? "Processing..." : (data?._id ? 'Update' : 'Submit')}</button>
                                        <button className="btn btn-outline-secondary w-50" onClick={handleReset}>Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageUser